import { Instance } from 'tippy.js'
import { DealDetail } from 'api'
import { ValidationCellRenderer, ValidationCellRendererParams } from 'view/components/datagrid'
import { RowDataGetter } from 'view/shared/datagrid'
import { ModificationType } from 'view/routes/requests/shared/deltaGetters'
import { getDealModificationColour } from 'view/routes/deals/components/utils'
import '../../requests/LiveNegotiationsGrid/NegotiableCellRenderer.css'

export interface NegotiableCellRendererParams extends ValidationCellRendererParams {
  getModificationType: (dealDetail: DealDetail) => ModificationType | null
  isRateField: boolean
  rowDataGetter?: RowDataGetter<DealDetail>
  validationField?: string | ((dealDetail: DealDetail) => string | null)
  dataTestId?: string
}

export class NegotiableCellRenderer extends ValidationCellRenderer {
  protected refreshCell(element: HTMLElement, tooltip: Instance, params: NegotiableCellRendererParams) {
    element.classList.toggle('negotiable-cell', true)
    super.refreshCell(element, tooltip, params)
    this.refreshModificationStyle(element, params)
  }

  private refreshModificationStyle(element: HTMLElement, params: NegotiableCellRendererParams) {
    const dealDetail = params.node.data
    const modificationColor = getDealModificationColour(params.getModificationType, dealDetail)
    const isModified = !!modificationColor
    const isTargetRate = !!params.isRateField && !!dealDetail && !isModified

    element.classList.toggle('modified', isModified)
    element.classList.toggle('target-rate', isTargetRate)
    element.style.borderBottomColor = modificationColor || ''
  }
}
